import { DateRangeModel } from 'app/core/mips/common/models/date-range.model';
import { DateUtility } from 'app/core/mips/common/utilities/date.utility';


export interface DateRange {
  timeDateRangeSelection: DateRangeModel | null;
}
  
export const initialTimeWeekState: DateRange = {
  timeDateRangeSelection: {
    startDate: DateUtility.getCurrentWeekDates().startDate,
    endDate: DateUtility.getCurrentWeekDates().endDate
  }
};